class SlideShowComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('.slideshow__slide');
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    this.querySelectorAll('.slider-counter__link').forEach((button, index) => {
      button.addEventListener('click', () => {
        this.slider.scrollTo({
          left: this.slider.getBoundingClientRect().width * index,
          behavior: 'smooth'
        });
      });
    });

    this.autoplaySpeed = parseInt(this.slider.dataset.speed) * 1000;
    this.autoplayEnabled = this.slider.dataset.autoplay === 'true';
    if (this.autoplayEnabled) this.play();

    const autoplayButton = this.querySelector('.slideshow__autoplay');
    if (autoplayButton) {
      autoplayButton.addEventListener('click', this.autoplayButtonClickHandler.bind(this));
    }

    this.slider.addEventListener('mouseenter', this.pause.bind(this));
    this.slider.addEventListener('mouseleave', () => { if (this.autoplayEnabled) this.play(); });
    this.slider.addEventListener('focusin', this.pause.bind(this));
    this.slider.addEventListener('focusout', () => { if (this.autoplayEnabled) this.play(); });

    this.update();
  }

  update() {
    const sliderWidth = this.slider.getBoundingClientRect().width;
    if (sliderWidth === 0) return;

    this.currentPage = Math.round(this.slider.scrollLeft / sliderWidth) + 1;

    if (this.currentPageElement) {
      this.currentPageElement.textContent = this.currentPage;
    }

    this.querySelectorAll('.slider-counter__link').forEach((button, index) => {
      button.classList.toggle('slider-counter__link--active', index === this.currentPage - 1);
      button.setAttribute('aria-current', index === this.currentPage - 1 ? 'true' : 'false');
    });

    if (this.prevButton) {
      this.currentPage === 1
        ? this.prevButton.setAttribute('disabled', 'disabled')
        : this.prevButton.removeAttribute('disabled');
    }

    if (this.nextButton) {
      this.currentPage === this.sliderItems.length
        ? this.nextButton.setAttribute('disabled', 'disabled')
        : this.nextButton.removeAttribute('disabled');
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const direction = event.currentTarget.name;
    const sliderWidth = this.slider.getBoundingClientRect().width;
    const scrollPosition = direction === 'next'
      ? this.slider.scrollLeft + sliderWidth
      : this.slider.scrollLeft - sliderWidth;
    this.slider.scrollTo({ left: scrollPosition, behavior: 'smooth' });
  }

  play() {
    this.pause();
    this.autoplayInterval = setInterval(this.autoplayStep.bind(this), this.autoplaySpeed);
  }

  pause() {
    clearInterval(this.autoplayInterval);
  }

  autoplayStep() {
    const sliderWidth = this.slider.getBoundingClientRect().width;
    const nextPage = this.currentPage < this.sliderItems.length ? this.currentPage : 0;
    this.slider.scrollTo({ left: nextPage * sliderWidth, behavior: 'smooth' });
  }

  autoplayButtonClickHandler(event) {
    event.preventDefault();
    const button = event.currentTarget;
    button.classList.toggle('slideshow__autoplay--paused');
    if (button.classList.contains('slideshow__autoplay--paused')) {
      this.pause();
      this.autoplayEnabled = false;
    } else {
      this.autoplayEnabled = true;
      this.play();
    }
  }
}

customElements.define('slideshow-component', SlideShowComponent);